"use client";

import Image from "next/image";
import { Calendar, Clock, ArrowLeft } from "lucide-react";
import Link from "next/link";

const blogPosts = [
    {
        id: 1,
        title: "راهنمای کامل خرید گیفت کارت استیم",
        excerpt: "در این مقاله به بررسی کامل نحوه خرید گیفت کارت استیم، مزایا و معایب آن می‌پردازیم...",
        image: "/gallery/7.jpg",
        date: "۱۴۰۲/۱۲/۱۵",
        readTime: "۵ دقیقه",
        category: "گیفت کارت",
    },
    {
        id: 2,
        title: "بهترین بازی‌های موبایل ۲۰۲۴",
        excerpt: "معرفی بهترین و پرفروش‌ترین بازی‌های موبایل در سال ۲۰۲۴ با بررسی ویژگی‌های هر کدام...",
        image: "/gallery/6.jpg",
        date: "۱۴۰۲/۱۲/۱۰",
        readTime: "۷ دقیقه",
        category: "بازی موبایل",
    },
    {
        id: 3,
        title: "نحوه افزایش رتبه در بازی پابجی",
        excerpt: "راهکارهای عملی و تکنیک‌های پیشرفته برای افزایش رتبه و بهبود عملکرد در بازی پابجی...",
        image: "/gallery/8.jpg",
        date: "۱۴۰۲/۱۲/۰۵",
        readTime: "۸ دقیقه",
        category: "پابجی",
    },
];

export const LatestBlogPosts = () => {
    return (
        <div className="relative bg-gradient-to-br from-background/90 to-background/50 backdrop-blur-md rounded-3xl border border-border/30 p-6 overflow-hidden">
            {/* Animated Background */}
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute top-0 right-0 w-40 h-40 bg-primary/5 rounded-full blur-3xl animate-pulse" />
                <div className="absolute bottom-0 left-0 w-32 h-32 bg-primary/5 rounded-full blur-2xl animate-pulse" style={{ animationDelay: '1s' }} />
            </div>

            {/* Content */}
            <div className="relative z-10">
                {/* Header */}
                <div className="flex items-center justify-between mb-8 gap-2">
                    <div className="flex items-center gap-4">
                        <div className="relative">
                            <div className="absolute inset-0 bg-primary/20 rounded-xl blur-xl animate-pulse" />
                            <div className="relative bg-primary/10 rounded-xl p-2 backdrop-blur-sm border border-primary/20">
                                <svg className="w-5 h-5 text-primary" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 20H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1m2 13a2 2 0 0 1-2-2V7m2 13a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <h2 className="text-xl font-bold bg-gradient-to-r from-primary via-primary/90 to-primary/80 bg-clip-text text-transparent">
                                آخرین مقالات
                            </h2>
                            <p className="text-sm text-muted-foreground mt-1">
                                جدیدترین مطالب آموزشی و راهنمایی
                            </p>
                        </div>
                    </div>
                    <Link 
                        href="/blog" 
                        className="group relative md:px-4 px-2 py-2 rounded-lg bg-primary/5 backdrop-blur-sm border border-primary/20 hover:bg-primary/10 transition-all duration-300"
                    >
                        <span className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground group-hover:text-primary transition-colors">
                            مشاهده همه
                            <ArrowLeft className="w-4 h-4 hidden md:flex transition-transform duration-300 group-hover:-translate-x-1" />
                        </span>
                        <div className="absolute inset-0 bg-gradient-to-r from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </Link>
                </div>

                {/* Blog Posts Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Featured Post */}
                    <Link 
                        href={`/blog/${blogPosts[0].id}`} 
                        className="group relative lg:col-span-2 flex flex-col lg:flex-row bg-card/50 backdrop-blur-sm rounded-2xl border border-border/30 overflow-hidden transition-all duration-500 hover:bg-card/80 hover:border-primary/30"
                    >
                        {/* Image Container */}
                        <div className="relative lg:w-1/2 h-64 lg:h-auto overflow-hidden">
                            <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/50 to-transparent z-10" />
                            <div className="relative w-full h-full transform transition-transform duration-700 group-hover:scale-110">
                                <Image
                                    src={blogPosts[0].image}
                                    alt={blogPosts[0].title}
                                    fill
                                    className="object-cover"
                                />
                            </div>
                            <div className="absolute top-4 right-4 z-20">
                                <span className="px-3 py-1 text-xs font-medium bg-primary/20 backdrop-blur-sm rounded-full text-primary">
                                    {blogPosts[0].category}
                                </span>
                            </div>
                        </div>

                        {/* Content */}
                        <div className="lg:w-1/2 p-6 flex flex-col justify-center">
                            <h3 className="text-2xl font-bold text-foreground group-hover:text-primary transition-colors duration-300">
                                {blogPosts[0].title}
                            </h3>
                            <p className="text-base text-muted-foreground mt-4 line-clamp-3">
                                {blogPosts[0].excerpt}
                            </p>

                            {/* Meta Info */}
                            <div className="mt-6 flex items-center gap-6 text-sm text-muted-foreground">
                                <div className="flex items-center gap-2">
                                    <Calendar className="w-5 h-5" />
                                    {blogPosts[0].date}
                                </div>
                                <div className="flex items-center gap-2">
                                    <Clock className="w-5 h-5" />
                                    {blogPosts[0].readTime}
                                </div>
                            </div>

                            {/* Read More Button */}
                            <div className="mt-6">
                                <span className="inline-flex items-center gap-2 text-sm text-primary group-hover:gap-3 transition-all duration-300">
                                    مطالعه بیشتر
                                    <ArrowLeft className="w-4 h-4" />
                                </span>
                            </div>
                        </div>

                        {/* Hover Effect */}
                        <div className="absolute inset-0 bg-gradient-to-t from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                    </Link>

                    {/* Other Posts */}
                    {blogPosts.slice(1).map((post) => (
                        <Link 
                            href={`/blog/${post.id}`} 
                            key={post.id}
                            className="group relative flex flex-col bg-card/50 backdrop-blur-sm rounded-2xl border border-border/30 overflow-hidden transition-all duration-500 hover:bg-card/80 hover:border-primary/30"
                        >
                            {/* Image Container */}
                            <div className="relative h-48 overflow-hidden">
                                <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-background/50 to-transparent z-10" />
                                <div className="relative w-full h-full transform transition-transform duration-700 group-hover:scale-110">
                                    <Image
                                        src={post.image}
                                        alt={post.title}
                                        fill
                                        className="object-cover"
                                    />
                                </div>
                                <div className="absolute top-4 right-4 z-20">
                                    <span className="px-3 py-1 text-xs font-medium bg-primary/20 backdrop-blur-sm rounded-full text-primary">
                                        {post.category}
                                    </span>
                                </div>
                            </div>

                            {/* Content */}
                            <div className="p-5 flex flex-col flex-grow">
                                <h3 className="text-lg font-semibold text-foreground group-hover:text-primary transition-colors duration-300">
                                    {post.title}
                                </h3>
                                <p className="text-sm text-muted-foreground mt-2 line-clamp-2">
                                    {post.excerpt}
                                </p>

                                {/* Meta Info */}
                                <div className="mt-4 flex items-center gap-4 text-xs text-muted-foreground">
                                    <div className="flex items-center gap-1">
                                        <Calendar className="w-4 h-4" />
                                        {post.date}
                                    </div>
                                    <div className="flex items-center gap-1">
                                        <Clock className="w-4 h-4" />
                                        {post.readTime}
                                    </div>
                                </div>
                            </div>

                            {/* Hover Effect */}
                            <div className="absolute inset-0 bg-gradient-to-t from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
}; 